import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static values = {
    url: String,
    fieldsContainer: String,
    param: String
  }
  connect(){
    let params = new URLSearchParams()
    params.append(this.paramValue, this.element.dataset.company)
    params.append('target', this.element.dataset.requestsFieldsContainerValue)
    this.sendRequest(params)
  }

  requestCompanies(e){
    let params = new URLSearchParams()
    params.append(this.paramValue, e.currentTarget.dataset.company)
    params.append('target', this.fieldsContainerValue)
    this.sendRequest(params)
  }

  sendRequest(params){
    get(`${this.urlValue}?${params}`, {
      responseKind: "turbo-stream"
    })
  }
}
